import { Grid, Section } from '@gogame/components';
import { FormField } from '@gogame/form';

import {
  loadAdditionalRewardConditions,
  loadRewards,
  loadAdditionalRewards,
} from 'scenes/Campaigns/sources/fields';

import {
  REWARD_PACKAGE,
  ADDITIONAL_REWARD_PACKAGE,
  ADDITIONAL_REWARD_CONDITION,
} from '../constants';
import { DEPENDENCIES } from '../dependencies';

export const RewardsSection = ({
  rewardPackage,
  withReward,
  withAdditionalReward,
  withAdditionalRewardCondition,
  disabled,
}) => {
  return (
    <Section title={'Reward'}>
      <Grid container spacing={3}>
        {withReward && (
          <Grid item xs={4}>
            <FormField.Select
              label={'Reward package'}
              padding={0}
              name={REWARD_PACKAGE}
              source={loadRewards}
              disabled={disabled}
              depends={DEPENDENCIES[REWARD_PACKAGE]}
            />
          </Grid>
        )}
        {withAdditionalReward && (
          <Grid item xs={4}>
            <FormField.Select
              label={'Additional reward package'}
              padding={0}
              name={ADDITIONAL_REWARD_PACKAGE}
              source={loadAdditionalRewards}
              lazy={true}
              disabled={!rewardPackage || disabled}
              depends={DEPENDENCIES[ADDITIONAL_REWARD_PACKAGE]}
            />
          </Grid>
        )}
        {withAdditionalRewardCondition && (
          <Grid item xs={4}>
            <FormField.Select
              label={'Additional reward condition'}
              padding={0}
              name={ADDITIONAL_REWARD_CONDITION}
              source={loadAdditionalRewardConditions}
              lazy={true}
              disabled={!rewardPackage || disabled}
              depends={DEPENDENCIES[ADDITIONAL_REWARD_CONDITION]}
            />
          </Grid>
        )}
      </Grid>
    </Section>
  );
};
